import { useState } from 'react';
import { useAfterResize } from '@/hooks/useAfterResize';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export const useBrandHubHeight = () => {
  const [brandHubHeight, setBrandHubHeight] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const handleSetBrandHubHeight = () => {
    const brandHub = document.querySelector('#BrandHub');
    if (brandHub) {
      setBrandHubHeight(brandHub.clientHeight);
    }
  };
  useAfterResize(handleSetBrandHubHeight, false, 150);
  useIsomorphicLayoutEffect(() => {
    window.addEventListener('brandHubResize', () => {
      // SetTimeout is needed to wait for the DOM to be updated
      setTimeout(handleSetBrandHubHeight, 10);
    });
    if (!initialized) {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('brandHubResize'));
      }, 150);
      setInitialized(true);
    }
  }, [initialized]);
  return brandHubHeight;
};
